<template>
  <tr class="border border-gray-400">
    <td class="w-30 border border-gray-400 text-center">
      {{ product.skuRelated }}
    </td>
    <td class="w-40 border border-gray-400">
      <img
        v-if="product.imageRoute"
        class="w-full"
        :src="product.imageRoute"
        :alt="product.skuRelated"
      />
      <span v-else class="w-full text-center">No image</span>
    </td>
    <td class="border border-gray-400">{{ product.title }}</td>
    <td class="border border-gray-400">{{ product.totalAvg }}</td>
    <td>
      <BaseModal id="sold-together-edition" v-model="showEditModal">
        <div class="flex flex-col p-10">
          <div>
            Product:
            <input
              type="text"
              class="regular clear full"
              v-model="baseCode"
              disabled
            />
          </div>
          <div>
            Related Product:
            <input
              type="text"
              class="regular clear full"
              v-model="product.skuRelated"
              disabled
            />
          </div>
          <div>
            Title:
            <input
              type="text"
              class="regular clear full"
              v-model="product.title"
              disabled
            />
          </div>
          <div>
            Orders Ranking:
            <input
              type="text"
              class="regular clear full"
              v-model="product.avgOrders"
              disabled
            />
          </div>
          <div>
            Manual Fix:
            <input
              type="number"
              step="1"
              class="regular clear full"
              v-model="newManualFix"
            />
          </div>
          <div>
            Total Avg:
            <input
              type="text"
              class="regular clear full"
              :value="Number(newManualFix) + Number(product.avgOrders)"
            />
          </div>
          <img
            class="w-80 mx-auto"
            :src="product.thumbnail || product.imageRoute"
          />
          <button
            class="btn-success-button mx-auto"
            v-if="newManualFix !== product.avgOrdersByUser"
            @click="saveUpdates"
          >
            Save
          </button>
        </div>
      </BaseModal>
      <button
        v-if="userCanEditProducts"
        @click="showEditModal = true"
        class="btn-info-button"
      >
        edit
      </button>
      <button
        v-if="userCanEditProducts"
        @click="deleteProductRelated"
        class="btn-info-button"
      >
        delete
      </button>
    </td>
  </tr>
</template>
<script>
import {
  updateSoldTogetherRelation,
  deleteSoldTogetherRelation
} from "@/api/store/ProductsService.js";

export default {
  name: "ProductsSoldTogetherItem",
  props: {
    baseCode: {
      type: String,
      required: true
    },
    product: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showEditModal: false,
      newManualFix: 0
    };
  },
  computed: {
    userCanEditProducts() {
      return this.$store.getters["auth/userHasPermission"]("can_edit_products");
    }
  },
  mounted() {
    this.newManualFix = this.product.avgOrdersByUser;
  },
  methods: {
    saveUpdates() {
      updateSoldTogetherRelation(
        this.baseCode,
        this.product.skuRelated,
        this.newManualFix
      ).then(() => {
        this.$emit("updated");
        this.$toast.open({
          message: `Product Updated`,
          type: "success",
          position: "top-right"
        });
      });
    },
    deleteProductRelated() {
      if (!confirm("confirm to delete tis product?")) return;

      deleteSoldTogetherRelation(this.baseCode, this.product.skuRelated).then(
        () => {
          this.$toast.open({
            message: `Product Deleted`,
            type: "success",
            position: "top-right"
          });
          this.$emit("deletedProduct");
        }
      );
    }
  }
};
</script>
<style lang="scss">
#sold-together-edition {
  .modal-content {
    max-width: 650px;
    height: auto;
  }
}
</style>
